//@flow

import styled, { keyframes } from 'styled-components';

const rotate360 = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const Spinner = styled.div`
  animation: ${rotate360} 1s linear infinite;
  margin: 0 auto;
  transform: translateZ(0);
  border: 1px solid ${props => (props.color ? props.color : '#278C7E')};
  border-left: 1px solid transparent;
  background: transparent;
  width: ${props => (props.size ? props.size : '24px')};
  height: ${props => (props.size ? props.size : '24px')};
  border-radius: 50%;
`;

export default Spinner;
